import { render, staticRenderFns } from "./project-activities-preview.vue?vue&type=template&id=47db45c2"
import script from "./project-activities-preview.vue?vue&type=script&lang=js"
export * from "./project-activities-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports